import { ChangedByInfoDto } from 'api';
import { CampaignType } from 'domain/campaign/CampaignType';
import { Status } from 'domain/constants/status';
import { joinTwoValuesWithSpace } from 'library/formatters/StringFormatter';

import { InstallationSubSystem } from './InstallationSubSystem';
import { MainSegment } from './MainSegment';
import { UnitIdentification } from './UnitIdentification';

export interface Unit {
	id: number;
	publicId: string;
	brandOrType: string | null;
	model: string | null;
	consumerLineOfBusiness: string | null;
	consumerUsingPurpose: string | null;
	mainSegment: MainSegment | null;
	identification: UnitIdentification | null;
	installations: Array<InstallationSubSystem>;
	status: Status | null;
	statusDate: Date | null;
	configurationChangedBy: ChangedByInfoDto | null;
	outstandingCampaignType: CampaignType | null;
	isBlueprint: boolean;
	manufacturerParmaId: number | null;
	manufacturerName: string | null;
}

export const getUnitTitle = (
	name: UnitIdentification['name'] | undefined,
	brandOrType: Unit['brandOrType'] | undefined,
	model: Unit['model'] | undefined
) => name || (brandOrType ? joinTwoValuesWithSpace(brandOrType, model) : '');

export const getProfilePicture = (imagesId: Array<number> | undefined) =>
	Array.isArray(imagesId) ? imagesId.at(0) : undefined;
